module.exports = __webpack_public_path__ + "static/media/Bumppy Payment SBI-01.9a2e400f.png";